import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  FaArrowLeft,
  FaMapMarkerAlt,
  FaBriefcase,
  FaCalendarAlt,
  FaFacebook,
  FaInstagram,
} from 'react-icons/fa';
import './LandingPage.css';

import logo from './assets/logo.png';
import imgPresidente from './assets/executivo/herminio_rodrigues.png';

import imgAssembleia0 from './assets/assembleia/carlos_marques.png';
import imgAssembleia1 from './assets/assembleia/catarina_serra.png';
import imgAssembleia2 from './assets/assembleia/duarte_machado.png';
import imgAssembleia3 from './assets/assembleia/eduardo_marques.png';
import imgAssembleia4 from './assets/assembleia/ines_bento.png';
import imgAssembleia5 from './assets/assembleia/jorge_boita.png';
import imgAssembleia6 from './assets/assembleia/liliana_duarte.png';
import imgAssembleia7 from './assets/assembleia/pedro_guerra.png';
import imgAssembleia8 from './assets/assembleia/ricardo_vigario.png';
import imgAssembleia9 from './assets/assembleia/susana_coito.png';
import imgAssembleia10 from './assets/assembleia/telmo_moleiro.png';
import imgAssembleia11 from './assets/assembleia/rute_pataca.png';
import imgAssembleia12 from './assets/assembleia/oscar_santos.png';
import imgAssembleia13 from './assets/assembleia/antonio_costa.png';
import imgAssembleia14 from './assets/assembleia/sandra_vicente.png';
import imgAssembleia15 from './assets/assembleia/patricia_almeida.png';
import imgAssembleia16 from './assets/assembleia/alvaro_antonio.png';
import imgAssembleia17 from './assets/assembleia/flavia_silva.png';
import imgAssembleia18 from './assets/assembleia/sofia_rosario.png';
import imgAssembleia19 from './assets/assembleia/afonso_oliveira.png';
import imgAssembleia20 from './assets/assembleia/filipa_borges.png';
import imgAssembleia21 from './assets/assembleia/rodrigo_carvalho.png';
import imgAssembleia22 from './assets/assembleia/carolina_delgado.png';
import imgAssembleia23 from './assets/assembleia/maria_moniz.png';
import imgAssembleia24 from './assets/assembleia/marco_duarte.png';
import imgAssembleia25 from './assets/assembleia/leonardo_tereso.png';
import imgAssembleia26 from './assets/assembleia/juliana_santos.png';
import imgAssembleia27 from './assets/assembleia/vitor_santos.png';
import imgAssembleia28 from './assets/assembleia/rita_machado_belo.png';
import imgAssembleia29 from './assets/assembleia/beatriz_borges.png';
import imgAssembleia30 from './assets/assembleia/bruno_rodrigues.png';
import imgAssembleia31 from './assets/assembleia/beatriz.png';
import imgAssembleia32 from './assets/assembleia/guilherme_freire.png';
import imgAssembleia33 from './assets/assembleia/maria_rita.png';
import imgAssembleia34 from './assets/assembleia/mariana_lage.png';

import imgExecutivo1 from './assets/executivo/herminio_rodrigues.png';
import imgExecutivo2 from './assets/executivo/jose_vinagre.png';
import imgExecutivo3 from './assets/executivo/paula_manojo.png';
import imgExecutivo4 from './assets/executivo/paulo_mateus.png';
import imgExecutivo5 from './assets/executivo/jose_mendes.png';
import imgExecutivo6 from './assets/executivo/ana_sofia.png';
import imgExecutivo7 from './assets/executivo/suzete_grosa.png';
import imgExecutivo8 from './assets/executivo/jacinto_francisco.png';
import imgExecutivo9 from './assets/executivo/tomas_letra.png';
import imgExecutivo10 from './assets/executivo/ines_parracho.png';
import imgExecutivo11 from './assets/executivo/rui_marques.png';
import imgExecutivo12 from './assets/executivo/alda_gomes.png';
import imgExecutivo13 from './assets/executivo/joana_duarte.png';
import imgExecutivo14 from './assets/executivo/jose_beato.png';

import imgJunta1 from './assets/junta/paulo_leao.png';
import imgJunta2 from './assets/junta/ines_delgado.png';
import imgJunta3 from './assets/junta/elia_pimenta.png';
import imgJunta4 from './assets/junta/marina_caetano.png';
import imgJunta5 from './assets/junta/paulo_nuno_eusebio.png';
import imgJunta6 from './assets/junta/cristiano_casimiro.png';
import imgJunta7 from './assets/junta/catarina_sousa.png';
import imgJunta8 from './assets/junta/dario_moleiro.png';
import imgJunta9 from './assets/junta/nuno_vieira.png';
import imgJunta10 from './assets/junta/silvia_tereso.png';
import imgJunta11 from './assets/junta/pedro_pombo.png';
import imgJunta12 from './assets/junta/2.png';
import imgJunta13 from './assets/junta/3.png';

import imgMandatario1 from './assets//mandatario/carlos_quiterio.png';
import imgMandatario2 from './assets//mandatario/jose_valentem.png';
import imgMandatario3 from './assets//mandatario/leonor_coelho.png';
import imgMandatario4 from './assets//mandatario/teresa_querido.png';

const CandidatosPage = () => {
  // Candidate data for all sections
  const presidente = {
    name: 'Hermínio Rodrigues',
    age: 55,
    profession: 'Empresário',
    location: 'Pataias',
    image: imgPresidente,
    description: 'Liderança experiente para um futuro próspero.',
  };

  const assembleiaMunicipal = [
    {
      name: 'Carlos Marques',
      age: 77,
      profession: 'Empresário',
      location: 'Alcobaça',
      image: imgAssembleia0,
    },
    {
      name: 'Liliana Duarte',
      age: 48,
      profession: 'Bancária',
      location: 'Vimeiro',
      image: imgAssembleia6,
    },
    {
      name: 'Pedro Guerra',
      age: 73,
      profession: 'Comerciante',
      location: 'Benedita',
      image: imgAssembleia7,
    },
    {
      name: 'Ricardo Vigário',
      age: 29,
      profession: 'Advogado',
      location: 'Alcobaça',
      image: imgAssembleia8,
    },
    {
      name: 'Susana Coito',
      age: 33,
      profession: 'Consultora',
      location: 'Turquel',
      image: imgAssembleia9,
    },
    {
      name: 'Eduardo Marques',
      age: 59,
      profession: 'Bancário',
      location: 'Alcobaça',
      image: imgAssembleia3,
    },
    {
      name: 'Telmo Moleiro',
      age: 60,
      profession: 'Empresário',
      location: 'Pataias',
      image: imgAssembleia10,
    },
    {
      name: 'Catarina Serra',
      age: 25,
      profession: 'Advogada',
      location: 'São Martinho do Porto',
      image: imgAssembleia1,
    },
    {
      name: 'Duarte Machado',
      age: 23,
      profession: 'Bancário',
      location: 'Aljubarrota',
      image: imgAssembleia2,
    },
    {
      name: 'Jorge Boita',
      age: 53,
      profession: 'Advogado',
      location: 'Benedita',
      image: imgAssembleia5,
    },
    {
      name: 'Inês Bento',
      age: 53,
      profession: 'Gestora',
      location: 'Cela',
      image: imgAssembleia4,
    },
    {
      name: 'Óscar Santos',
      age: 63,
      profession: 'Gestor de Projectos',
      location: 'Montes',
      image: imgAssembleia12,
    },
    {
      name: 'Rute Pataca',
      age: 30,
      profession: 'Técnica Superior',
      location: 'Martingança',
      image: imgAssembleia11,
    },
    {
      name: 'António da Costa',
      age: 65,
      profession: 'Reformado',
      location: 'Alcobaça',
      image: imgAssembleia13,
    },
    {
      name: 'Sandra Vicente',
      age: 53,
      profession: 'Advogada',
      location: 'Alcobaça',
      image: imgAssembleia14,
    },
    {
      name: 'Patrícia de Almeida',
      age: 40,
      profession: 'Consultora',
      location: 'Benedita',
      image: imgAssembleia15,
    },
    {
      name: 'Álvaro António',
      age: 57,
      profession: 'Engenheiro de Produção Animal',
      location: 'Alcobaça',
      image: imgAssembleia16,
    },
    {
      name: 'Flávia da Silva',
      age: 30,
      profession: 'Professora',
      location: 'Alcobaça',
      image: imgAssembleia17,
    },
    {
      name: 'Sofia do Rosário',
      age: 29,
      profession: 'Médica',
      location: 'Alcobaça',
      image: imgAssembleia18,
    },
    {
      name: 'Afonso Oliveira',
      age: 21,
      profession: 'Estudante',
      location: 'Alcobaça',
      image: imgAssembleia19,
    },
    {
      name: 'Filipa Pires e Borges',
      age: 28,
      profession: 'Junior Communication and Stakeholder Relations Officer',
      location: 'Alcobaça',
      image: imgAssembleia20,
    },
    {
      name: 'Rodrigo Carvalho',
      age: 18,
      profession: 'Estudante',
      location: 'Alcobaça',
      image: imgAssembleia21,
    },
    {
      name: 'Carolina Delgado',
      age: 18,
      profession: 'Estudante',
      location: 'Alcobaça',
      image: imgAssembleia22,
    },
    {
      name: 'Maria Moniz',
      age: 27,
      profession: 'Analista Financeira',
      location: 'Alcobaça',
      image: imgAssembleia23,
    },
    {
      name: 'Marco Duarte',
      age: 38,
      profession: 'Empresário',
      location: 'Alcobaça',
      image: imgAssembleia24,
    },
    {
      name: 'Leonardo Tereso',
      age: 26,
      profession: 'Engenheiro Zootécnico',
      location: 'Alcobaça',
      image: imgAssembleia25,
    },
    {
      name: 'Juliana Santos',
      age: 47,
      profession: 'Contabilista Certificada',
      location: 'Alcobaça',
      image: imgAssembleia26,
    },
    {
      name: 'Vítor dos Santos',
      age: 62,
      profession: 'Empresário',
      location: 'Alcobaça',
      image: imgAssembleia27,
    },
    {
      name: 'Rita Belo',
      age: 23,
      profession: 'Analista Financeira',
      location: 'Alcobaça',
      image: imgAssembleia28,
    },
    {
      name: 'Beatriz Borges',
      age: 28,
      profession: 'Enfermeira',
      location: 'Alcobaça',
      image: imgAssembleia29,
    },
    {
      name: 'Bruno Rodrigues',
      age: 27,
      profession: 'Consultor',
      location: 'Alcobaça',
      image: imgAssembleia30,
    },
    {
      name: 'Beatriz Silva',
      age: 20,
      profession: 'Estudante',
      location: 'Alcobaça',
      image: imgAssembleia31,
    },
    {
      name: 'Guilherme Freire',
      age: 19,
      profession: 'Distribuidor',
      location: 'Alcobaça',
      image: imgAssembleia32,
    },
    {
      name: 'Maria Rita',
      age: 26,
      profession: 'Designer de Moda',
      location: 'Alcobaça',
      image: imgAssembleia33,
    },
    {
      name: 'Mariana Lage',
      age: 26,
      profession: 'Administrativa',
      location: 'Alcobaça',
      image: imgAssembleia34,
    },
  ];

  const executivoMunicipal = [
    {
      name: 'Hermínio Rodrigues',
      age: 55,
      profession: 'Empresário',
      location: 'Pataias',
      image: imgExecutivo1,
    },
    {
      name: 'José Vinagre',
      age: 46,
      profession: 'Professor',
      location: 'Benedita',
      image: imgExecutivo2,
    },
    {
      name: 'Paula Malojo',
      age: 60,
      profession: 'Professora',
      location: 'Alcobaça',
      image: imgExecutivo3,
    },
    {
      name: 'Paulo Mateus',
      age: 53,
      profession: 'Empresário',
      location: 'Cela',
      image: imgExecutivo4,
    },
    {
      name: 'José Mendes',
      age: 23,
      profession: 'Consultor',
      location: 'Alcobaça',
      image: imgExecutivo5,
    },
    {
      name: 'Ana Sofia',
      age: 23,
      profession: 'Advogada',
      location: 'Alfeizerão',
      image: imgExecutivo6,
    },
    {
      name: 'Suzete Grosa',
      age: 50,
      profession: 'Arquiteta',
      location: 'Benedita',
      image: imgExecutivo7,
    },
    {
      name: 'Jacinto Francisco',
      age: 57,
      profession: 'Gestor Comercial',
      location: 'Alcobaça',
      image: imgExecutivo8,
    },
    {
      name: 'Tomás Letra',
      age: 21,
      profession: 'Estudante',
      location: 'Alcobaça',
      image: imgExecutivo9,
    },
    {
      name: 'Inês Parracho',
      age: 24,
      profession: 'Psicóloga Clínica Júnior',
      location: 'Alcobaça',
      image: imgExecutivo10,
    },
    {
      name: 'Rui Marques',
      age: 52,
      profession: 'Empresário',
      location: 'Alcobaça',
      image: imgExecutivo11,
    },
    {
      name: 'Alda Gomes',
      age: 65,
      profession: 'Socióloga e Diretora Técnica',
      location: 'Alcobaça',
      image: imgExecutivo12,
    },
    {
      name: 'Joana Duarte',
      age: 26,
      profession: 'Técnica de Marketing',
      location: 'Alcobaça',
      image: imgExecutivo13,
    },
    {
      name: 'José Gonçalves',
      age: 80,
      profession: 'Engenheiro Electrotécnico',
      location: 'Alcobaça',
      image: imgExecutivo14,
    },
  ];

  const juntasFreguesia = [
    {
      name: 'Paulo Leão',
      age: 61,
      profession: 'Gestor Comercial',
      location: 'Alcobaça e Vestiaria',
      image: imgJunta1,
    },
    {
      name: 'Inês Delgado',
      age: 30,
      profession: 'Técnica de Marketing',
      location: 'Alfeizerão',
      image: imgJunta2,
    },
    {
      name: 'Élia Pimenta',
      age: 48,
      profession: 'Engenheira Agrícola',
      location: 'Aljubarrota',
      image: imgJunta3,
    },
    {
      name: 'Marina Caetano',
      age: 51,
      profession: 'Professora',
      location: 'Benedita',
      image: imgJunta4,
    },
    {
      name: 'Paulo Nuno Eusébio',
      age: 61,
      profession: 'Comerciante',
      location: 'Cela',
      image: imgJunta5,
    },
    {
      name: 'Cristiano Casimiro',
      age: 34,
      profession: 'Operário Fabril',
      location: 'Coz, Alpedriz e Montes',
      image: imgJunta6,
    },
    {
      name: 'Catarina Santos',
      age: 45,
      profession: 'Assistente Operacional',
      location: 'Évora de Alcobaça',
      image: imgJunta7,
    },
    {
      name: 'Dário Moleiro',
      age: 51,
      profession: 'Engenheiro Mecânico',
      location: 'Pataias e Martingança',
      image: imgJunta8,
    },
    {
      name: 'Nuno Vieira',
      age: 50,
      profession: 'Empresário',
      location: 'São Martinho do Porto',
      image: imgJunta9,
    },
    {
      name: 'Sílvia Tereso',
      age: 41,
      profession: 'Coordenadora de Formação',
      location: 'Turquel',
      image: imgJunta10,
    },
    {
      name: 'Pedro Pombo',
      age: 55,
      profession: 'Comerciante',
      location: 'Vimeiro',
      image: imgJunta11,
    },
    {
      name: 'Filipe Ribeiro',
      label: 'Independente',
      age: 47,
      profession: 'Empresário Agrícola',
      location: 'Barrio',
      image: imgJunta12,
    },
    {
      name: 'Sérgio Rocha',
      label: 'Independente',
      age: 53,
      profession: 'Empresário',
      location: 'Maiorga',
      image: imgJunta13,
    },
  ];

  const mandatarios = [
    {
      name: 'Dr. Carlos Quitério',
      age: 49,
      profession: 'Médico',
      location: 'Alcobaça',
      image: imgMandatario1,
      area: (
        <p>
          Mandatário da
          <br />
          Campanha
        </p>
      ),
    },
    {
      name: 'José Valentim',
      age: 49,
      profession: 'Economista',
      location: 'Alcobaça',
      image: imgMandatario2,
      area: (
        <p>
          Mandatário
          <br />
          Digital
        </p>
      ),
    },
    {
      name: 'Leonor Coelho',
      age: 49,
      profession: 'Economista',
      location: 'Alcobaça',
      image: imgMandatario3,
      area: (
        <p>
          Mandatária da
          <br />
          Juventude
        </p>
      ),
    },
    {
      name: 'Teresa Querido',
      age: 49,
      profession: 'Economista',
      location: 'Alcobaça',
      image: imgMandatario4,
      area: (
        <p>
          Mandatária
          <br />
          Financeira
        </p>
      ),
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  const CandidateCard = ({ candidate, isPresident = false }) => (
    <motion.div
      variants={itemVariants}
      className={`bg-white rounded-2xl shadow-lg ${
        isPresident ? 'md:col-span-2 lg:col-span-1' : ''
      }`}
    >
      <div className='relative'>
        <img
          src={candidate.image}
          alt={candidate.name}
          className='w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300'
        />
        {candidate.area && (
          <div className='absolute top-4 left-4 bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-medium'>
            {candidate.area}
          </div>
        )}
      </div>
      <div className='p-6'>
        <h3 className='text-xl font-bold text-gray-900 mb-2'>
          {candidate.name}
          <p className='text-sm font-normal text-gray-500 mt-1'>
            {candidate.label}
          </p>
        </h3>
        <div className='space-y-2 text-gray-600'>
          <div className='flex items-center'>
            <FaCalendarAlt className='w-4 h-4 text-orange-600 mr-2' />
            <span>{candidate.age} anos</span>
          </div>
          <div className='flex items-center'>
            <FaBriefcase className='w-4 h-4 text-orange-600 mr-2' />
            <span>{candidate.profession}</span>
          </div>
          <div className='flex items-center'>
            <FaMapMarkerAlt className='w-4 h-4 text-orange-600 mr-2' />
            <span>{candidate.location}</span>
          </div>
        </div>
        {candidate.description && (
          <p className='mt-4 text-gray-600 italic'>{candidate.description}</p>
        )}
      </div>
    </motion.div>
  );

  const MandateCard = ({ candidate, isPresident = false }) => (
    <motion.div
      variants={itemVariants}
      className={`bg-white rounded-2xl shadow-lg ${
        isPresident ? 'md:col-span-2 lg:col-span-1' : ''
      }`}
    >
      <div className='relative'>
        <img
          src={candidate.image}
          alt={candidate.name}
          className='w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300'
        />
        {candidate.area && (
          <div className='absolute top-4 left-4 bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-medium'>
            {candidate.area}
          </div>
        )}
      </div>
      <div className='p-6'>
        <h3 className='text-xl font-bold text-gray-900 mb-2'>
          {candidate.name}
        </h3>
      </div>
    </motion.div>
  );

  const SectionTitle = ({ title, subtitle }) => (
    <motion.div variants={itemVariants} className='text-center mb-12'>
      <h2 className='text-3xl md:text-4xl font-bold text-gray-900 mb-4'>
        <span className='text-orange-600'>{title}</span>
      </h2>
      {subtitle && (
        <p className='text-lg text-gray-600 max-w-2xl mx-auto'>{subtitle}</p>
      )}
      <div className='w-24 h-1 bg-orange-600 mx-auto mt-4'></div>
    </motion.div>
  );

  return (
    <div className='min-h-svh bg-gray-50'>
      {/* Header */}
      <header className='bg-orange-600 text-white py-8'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='flex items-center justify-between'>
            <Link
              to='/'
              className='flex items-center space-x-2 text-white hover:text-orange-200 transition-colors duration-300'
            >
              <FaArrowLeft className='w-5 h-5' />
            </Link>
            <div className='text-center'>
              <h1 className='text-4xl md:text-5xl font-bold mb-2'>
                CANDIDATOS
              </h1>
              <p className='text-orange-100'>
                Sempre Consigo. Sempre pelo Concelho de Alcobaça.
              </p>
            </div>
            <div className='w-20'></div> {/* Spacer for alignment */}
          </div>
        </div>
      </header>

      {/* Content */}
      <main className='py-16'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          {/* 1. Candidato a Presidente 
          <motion.section
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="mb-20"
          >
            <SectionTitle 
              title="CANDIDATO A PRESIDENTE"
            />
            
            <div className="flex justify-center">
              <div className="max-w-md">
                <CandidateCard candidate={presidente} isPresident />
              </div>
            </div>
          </motion.section>
          */}

          {/* 3. Candidatos ao Executivo Municipal */}
          <motion.section
            variants={containerVariants}
            initial='visible'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='mb-20'
          >
            <SectionTitle title='CANDIDATOS AO EXECUTIVO MUNICIPAL' />

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8'>
              {executivoMunicipal.map((candidate, index) => (
                <CandidateCard key={index} candidate={candidate} />
              ))}
            </div>
          </motion.section>

          {/* 2. Candidatos à Assembleia Municipal */}
          <motion.section
            variants={containerVariants}
            initial='visible'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='mb-20'
          >
            <SectionTitle title='CANDIDATOS À ASSEMBLEIA MUNICIPAL' />

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
              {assembleiaMunicipal.map((candidate, index) => (
                <CandidateCard key={index} candidate={candidate} />
              ))}
            </div>
          </motion.section>

          {/* 4. Candidatos às Juntas de Freguesia */}
          <motion.section
            variants={containerVariants}
            initial='visible'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='mb-20'
          >
            <SectionTitle title='CANDIDATOS ÀS JUNTAS DE FREGUESIA' />

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
              {juntasFreguesia.map((candidate, index) => (
                <CandidateCard key={index} candidate={candidate} />
              ))}
            </div>
          </motion.section>

          {/* 5. Mandatários */}
          <motion.section
            variants={containerVariants}
            initial='visible'
            whileInView='visible'
            viewport={{ once: true, amount: 0.3 }}
            className='mb-20'
          >
            <SectionTitle title='MANDATÁRIOS' />

            <div className='grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto'>
              {mandatarios.map((candidate, index) => (
                <MandateCard key={index} candidate={candidate} />
              ))}
            </div>
          </motion.section>
        </div>
      </main>

      {/* Footer */}
      <footer id='contactos' className='bg-orange-600 text-white py-16'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12'>
            {/* Brand Section */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className='flex items-center space-x-3 mb-6'>
                <div className='relative'>
                  <img
                    src={logo}
                    alt='Hermínio Rodrigues - Logótipo'
                    className='relative z-10 w-full max-w-md lg:max-w-lg h-auto'
                  />
                </div>
              </div>
              <div className='flex space-x-4'>
                <p className='text-white/80 text-lg mb-6 text-justify'>
                  <span className='font-bold'>Sempre consigo.</span> <br />
                  Sempre pelo Concelho de Alcobaça.
                </p>
              </div>
              <div className='flex space-x-4'>
                <a
                  href='https://www.facebook.com/AquiConsigo21/'
                  className='text-white hover:text-orange-200 transition-colors duration-300'
                >
                  <FaFacebook size={40} />
                </a>
                <a
                  href='https://www.instagram.com/aquiconsigo2021/'
                  className='text-white hover:text-orange-200 transition-colors duration-300'
                >
                  <FaInstagram size={40} />
                </a>
              </div>
            </motion.div>
          </div>

          <div className='mt-12 pt-8 border-t border-white/20 text-center'>
            <p className='text-white/80'>
              ©2025 PSD Alcobaça - Todos os direitos reservados.{' '}
              <a href='mailto:geral@sempreconsigo.pt?subject=Sempre Consigo'>
                geral@sempreconsigo.pt
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CandidatosPage;
